var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvalanche(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: "24px",
    height: "24px",
    viewBox: "0 0 32 32",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "social icon for avalanche") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E84142",
    fillRule: "evenodd",
    d: "M31.99 16.01a15.99 15.99 0 1 1-31.98 0 15.99 15.99 0 0 1 31.98 0Zm-20.52 6.36h-3.1c-.66 0-.98 0-1.17-.12a.79.79 0 0 1-.36-.62c-.01-.23.15-.51.47-1.08l7.66-13.5c.33-.58.5-.86.7-.97a.8.8 0 0 1 .72 0c.2.1.37.4.7.97l1.57 2.75c.36.62.54.94.62 1.26.08.36.08.74 0 1.1-.08.33-.26.64-.62 1.26l-4.02 7.12-.01.02c-.36.62-.54.93-.78 1.17-.28.26-.6.45-.96.55-.32.1-.69.1-1.42.1Zm7.84 0h4.44c.66 0 .99 0 1.18-.13a.79.79 0 0 0 .36-.62c.01-.22-.14-.5-.45-1.03l-.04-.05-2.22-3.81-.03-.04c-.31-.53-.47-.8-.67-.9a.78.78 0 0 0-.71 0c-.2.1-.37.38-.7.94l-2.22 3.81v.02c-.33.56-.5.84-.48 1.07a.8.8 0 0 0 .36.62c.19.12.52.12 1.18.12Z",
    clipRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvalanche);
export default __webpack_public_path__ + "static/media/avalanche.7f6ff7cc1cc6ef59704bbf0bf9ad7226.svg";
export { ForwardRef as ReactComponent };